import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import { getQuestionnaireIntro } from 'src/ui/features/Questionnaire/state/questionnaireActions';
import { QuestionnaireCompletePres } from '../presentational/QuestionnaireCompletePres';
import { addToHistory } from 'src/utils/utilsActions';

class QuestionnaireCompleteContainer extends Component {
  componentDidMount() {
    this.getIntroData();
    //this.props.addToHistory(window.location.pathname);
  }
  getIntroData = () => {
    const { getQuestionnaireIntro, match } = this.props;
    return getQuestionnaireIntro({ ...match.params, complete: true });
  };
  render() {
    return <QuestionnaireCompletePres {...this.props} />;
  }
}

const mapStateToProps = state => ({
  gettingIntroData: state.questionnaire.gettingIntroData,
  introData: state.questionnaire.intro,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
});

const mapDispatchToProps = {
  getQuestionnaireIntro,
  push,
  goBack,
  addToHistory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuestionnaireCompleteContainer);
